//based on https://gist.githubusercontent.com/kaungmyatlwin/87f947b971a2ad777f4e0fde134893a8/raw/ab51eb5c0c54866c46fe1187ef30676d80ba30f8/EditableText.js

import React, { useState, useRef, useEffect } from "react";

interface Props {
  text: string;
  onChange?: (changedText:string) => Promise<void>
}


const EditableInput: React.FC<Props> = props => {
  // We use hooks to declare "initial" states
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputVisible, setInputVisible] = useState(false);
  const [text, setText] = useState(props.text);
  const [processing, setProcessing] = useState(false);

  function onClickOutSide(e:MouseEvent) {
    // Check if user is clicking outside of <input>
    if (inputRef.current && !inputRef.current.contains(e.target as Node|null)) {
      const newText = inputRef.current.value
      setProcessing(true);
      if(newText.trim() && newText != text) {
        (props.onChange ? props.onChange(newText) : Promise.resolve()).then(() => {
          setInputVisible(false);
          setProcessing(false);
        })
        .catch(() => {
          setText(text);
          setInputVisible(false);
          setProcessing(false);
        })
      }
      else {
        if(!newText.trim()) setText(text);
        setInputVisible(false); // Disable text input
        setProcessing(false);
      }
    }
  }

  useEffect(() => {
    // Handle outside clicks on mounted state
    if (inputVisible) {
      document.addEventListener("mousedown", onClickOutSide);
      return () => {
        // This is a necessary step to "dismount" unnecessary events when we destroy the component
        document.removeEventListener("mousedown", onClickOutSide);
      };
    }

    return () => {}
  },[inputVisible]);

  return (
    <React.Fragment>
      {inputVisible ? (
        <input
          ref={inputRef} // Set the Ref
          value={text} // Now input value uses local state
          onChange={e => {
            setText(e.target.value);
          }}
          disabled={processing}
        />
      ) : (
        <span onClick={() => setInputVisible(true)}>{text}</span>
      )}
    </React.Fragment>
  );
};

export default EditableInput;